import { render, staticRenderFns } from "./TechAreasPageDetails.vue?vue&type=template&id=10ee2c54&"
import script from "./TechAreasPageDetails.vue?vue&type=script&lang=ts&"
export * from "./TechAreasPageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ee2c54')) {
      api.createRecord('10ee2c54', component.options)
    } else {
      api.reload('10ee2c54', component.options)
    }
    module.hot.accept("./TechAreasPageDetails.vue?vue&type=template&id=10ee2c54&", function () {
      api.rerender('10ee2c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/TechAreas/TechAreasPageDetails.vue"
export default component.exports